export const emailVerifyFields = [
  {
    name: "email",
    type: "email",
    htmlFor: "email",
    placeholder: "enter your email",
    label: "Email",
  },
];

export const registerfields = [
  {
    name: "email",
    type: "email",
    htmlFor: "email",
    placeholder: "enter your email",
    label: "Email",
  },
  {
    name: "organization",
    type: "text",
    htmlFor: "organization",
    placeholder: "enter your organization",
    label: "Organization",
  },
  {
    name: "businessType",
    type: "text",
    htmlFor: "businessType",
    placeholder: "enter your business type",
    label: "Business Type",
    nonMandatory: true,
  },
  {
    name: "address",
    type: "textarea",
    htmlFor: "address",
    placeholder: "enter your address",
    label: "Address",
  },
  {
    name: "phone",
    type: "text",
    htmlFor: "phone",
    placeholder: "enter your phone number",
    label: "Phone Number",
  },
  {
    name: "password",
    type: "password",
    htmlFor: "password",
    placeholder: "enter your password",
    label: "Password",
  },
  {
    name: "confirmPassword",
    type: "password",
    htmlFor: "confirmPassword",
    placeholder: "confirm new password",
    label: "Confirm New Password",
  },
];

export const loginFields = [
  {
    name: "username",
    type: "text",
    htmlFor: "username",
    placeholder: "enter your username",
    label: "Username",
  },
  {
    name: "password",
    type: "password",
    htmlFor: "password",
    placeholder: "enter your password",
    label: "Password",
  },
];
export const licenseFields = [
  {
    name: "license",
    type: "textarea",
    htmlFor: "license",
    placeholder: "enter your license key",
    label: "Key",
  }
];
export const resetPassFields = [
  {
    name: "recoveryCode",
    type: "text",
    htmlFor: "recoveryCode",
    placeholder: "enter recovey code",
    label: "Recovery Code",
  },
  {
    name: "new_password",
    type: "password",
    htmlFor: "new_password",
    placeholder: "enter new password",
    label: "New Password",
  },
  {
    name: "confirm_password",
    type: "password",
    htmlFor: "confirm_password",
    placeholder: "confirm new password",
    label: "Confirm New Password",
  },
];

export const dateFormatter = (date, format) => {
  let _date = new Date(date);
  let DATE = _date.getDate(),
    MONTH = _date.getMonth() + 1,
    MONTH_NAME = _date.toDateString().split(" ")[1],
    YEAR = _date.getFullYear(),
    HOUR = _date.getHours(),
    MINS = _date.getMinutes(),
    SECONDS = _date.getSeconds();

  return dateFormatRef(format, {
    date: DATE,
    month: MONTH,
    monthName: MONTH_NAME,
    year: YEAR,
    hour: HOUR,
    mins: MINS,
    seconds: SECONDS,
  });
};

const dateFormatRef = (
  format,
  { date, month, monthName, year, hour, mins, seconds }
) => {
  const zeroHandled = (number) => {
    return number < 10 ? "0" + number : number;
  };

  switch (format) {
    case "yyyy/MM/dd":
      return `${year}/${zeroHandled(month)}/${zeroHandled(date)}`;
    case "dd/MM/yy":
      return `${zeroHandled(date)}/${zeroHandled(month)}/${String(year).slice(
        2
      )}`;
    case "dd/MM/yyyy":
      return `${zeroHandled(date)}/${zeroHandled(month)}/${year}`;
    case "dd/MMM/yyyy":
      return `${zeroHandled(date)}/${monthName}/${year}`;
    case "MM/dd/yyyy":
      return `${zeroHandled(month)}/${zeroHandled(date)}/${year}`;
    case "yyyy/MM/dd HH:mm:ss":
      return `${year}/${zeroHandled(month)}/${zeroHandled(date)} ${zeroHandled(
        hour
      )}:${zeroHandled(mins)}:${zeroHandled(seconds)}`;
    default:
      return `${zeroHandled(date)} ${monthName} ${year}`;
  }
};
